import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'vex-breadcrumb',
	template: `
		<ng-content></ng-content>
	`,
	styles: [],
	host: {
		class: 'vex-breadcrumb body-2 text-zinc-300 leading-none hover:text-white no-underline trans-ease-out ltr:mr-2 rtl:ml-2',
	},
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class BreadcrumbComponent {}
